import styled from 'styled-components';

import { Input, InputGroup, theme } from '@notino/react-styleguide-v20';

import { Bold } from '@styles/generalStyles';

export const StyledInputGroupWithButton = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledLabel = styled(Bold)`
  margin-bottom: 0.325rem;
`;

export const StyledInputGroup = styled(InputGroup)`
  flex-grow: 1;
`;

export const StyledInput = styled(Input)<{ errorBorder?: boolean }>`
  border-bottom: 1px solid ${({ errorBorder }) => (errorBorder ? theme.color.border.negative : 'inherit')};
`;
